var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"icons",staticClass:"icons-container",style:({ left: _vm.left + 'px', top: _vm.top + 'px' })},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }